// extracted by mini-css-extract-plugin
export default {"progress-wrap":"ActionProgress_progress-wrap__ofEqm","percent":"ActionProgress_percent__eNu6J"};